import { useEffect, useState, useCallback } from 'react'
import { getTurnoCaixaAtual, type TurnoCaixa } from '../api/client'

/**
 * Hook que expõe o turno de caixa aberto do usuário logado (D-102, 2026-05-16).
 *
 * - Perfis 'caixa' e 'admin' têm turno opcional. Atendente/segurança não usam.
 * - Faz fetch inicial em `getTurnoCaixaAtual()` e disponibiliza `refresh()` para
 *   refetch após abrir/fechar.
 * - Retorna { aberto, turno, loading, error, refresh }.
 *
 * Como NÃO é Provider/Context, cada consumidor faz seu próprio fetch. Para
 * usuários sem necessidade (atendente), o `enabled=false` evita request.
 */
export function useTurnoCaixa(enabled: boolean = true) {
  const [aberto, setAberto] = useState(false)
  const [turno, setTurno] = useState<TurnoCaixa | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string>('')

  const refresh = useCallback(async () => {
    if (!enabled) {
      setLoading(false)
      return
    }
    setLoading(true)
    setError('')
    try {
      const r = await getTurnoCaixaAtual()
      setAberto(r.aberto)
      setTurno(r.turno)
    } catch (e: any) {
      setError(e?.message || 'Erro ao consultar turno')
    } finally {
      setLoading(false)
    }
  }, [enabled])

  useEffect(() => {
    refresh()
  }, [refresh])

  return { aberto, turno, loading, error, refresh }
}
